import { render, staticRenderFns } from "./Invitationedit.vue?vue&type=template&id=3b945497&scoped=true"
import script from "./Invitationedit.vue?vue&type=script&lang=js"
export * from "./Invitationedit.vue?vue&type=script&lang=js"
import style0 from "./Invitationedit.vue?vue&type=style&index=0&id=3b945497&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b945497",
  null
  
)

export default component.exports